"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePreloadTags = void 0;
function generatePreloadTags(preloadTags) {
    if (preloadTags === null || preloadTags === void 0 ? void 0 : preloadTags.length) {
        const json = {};
        preloadTags.forEach((tag, i) => {
            if (tag.type) {
                const key = `${tag.type}.${i}`;
                json[key] = tag;
            }
        });
        return { json };
    }
    return { json: {} };
}
exports.generatePreloadTags = generatePreloadTags;
